import * as pbi from '../../public/index.component'
import { $ } from 'protractor';

@pbi.Component({
    selector: 'leftmenu',
    templateUrl: './leftmenu.component.html'
})
export class LeftMenuComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    items: any = [];
    //#region Url
    presentation: any = '/admin/page/presentation';
    presentationUser: any = '/admin/page/presentationuser';
    //#endregion Url
    constructor(private router: pbi.Router) {
        this.items.push(
            {user:'adminPDF', router: this.presentation },
            {user:'adminPDF', router: this.presentationUser },
        );
    }
    ngOnInit() {

    };

    ActiveLink(a) {
        return this.router.url === a;
    }

    PhanQuyen(a) {
        let ok = true;
        var userName = window.localStorage.getItem('userName');
        if(userName != 'superadmin') {
            let items = this.items.filter(function(index, val){
                return val.user == userName && val.router == a
            });

            if(items.length <= 0)
                ok = false;
            else
                ok = true;
        }
        return ok;
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/leftmenu/leftmenu.component.ts